import React, { useState } from 'react';
import useSWR from 'swr';
import { Grid, Button, useToast } from '@chakra-ui/react';
import { Resume } from '../../components/Card';
import baseService from '../../services/base';
import Loader from '../../components/Feedback/Loader';
import {
  AttentionModal,
  SuccessModal,
  QuestionnaireTypeSelection,
} from '../../components/Modals';
import { backgroundOptions } from '../../assets/new-images/backgrounds';
import { MainContent, PageHeaderStructure } from '../../components/Layout';
import { pageHeaderContent } from '../../resources/content';
import { fetchData } from '../../services/fetch';

export default function Researches() {
  const toast = useToast();
  const [currentResearch, setCurrentResearch] = useState();
  const [success, setSuccess] = useState(false);

  const { data: companies } = useSWR(`/company`, fetchData);

  const { data: researchData, isLoading, mutate } = useSWR('/survey', fetchData);

  const companyId = companies?.length ? companies?.[0]?.id_company : null;
  const [deleteSubmitIsLoading, setDeleteSubmitIsLoading] = useState(false);
  const [deleteConfirmationIsOpen, setDeleteConfirmationIsOpen] = useState(false);

  function openDeleteConfirmation(research) {
    setCurrentResearch(research.id_survey);
    setDeleteConfirmationIsOpen(true);
  }

  const handleDelete = async () => {
    setDeleteSubmitIsLoading(true);
    try {
      const response = await baseService.delete(`/survey/${currentResearch}`);
      setDeleteConfirmationIsOpen(false);
      setSuccess(true);
    } catch (err) {
      toast({
        title: 'Erro ao excluir pergunta',
        description:
          'Não é permitido deletar pesquisas com perguntas cadastradas. Contate uma pessoa administradora.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setDeleteSubmitIsLoading(false);
    }
  };

  const handleClose = () => {
    mutate();
    setDeleteConfirmationIsOpen(false);
    setSuccess(false);
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <MainContent>
      <PageHeaderStructure
        title={pageHeaderContent.researches.title}
        subtitle={pageHeaderContent.researches.subtitle}
      >
        <QuestionnaireTypeSelection />
      </PageHeaderStructure>

      <Grid templateColumns="repeat(2, 1fr)" gap="12px" mt="32px">
        {researchData?.map((value, index) => (
          <Resume
            key={index}
            bg={backgroundOptions[index % backgroundOptions?.length]}
            title={value?.description}
            subtitle=""
            link={
              value?.type === 'simple'
                ? `/researches/edit/${value?.id_survey}`
                : value?.type === 'diagnostic'
                ? `/researches/diagnosis/${value?.id_survey}?cr=${companyId}`
                : value?.type === 'periodic'
                ? `/researches/periodic/${value?.id_survey}?cr=${companyId}`
                : `/researches/certification/${value?.id_survey}?cr=${companyId}`
            }
            linkLabel="Ver questionário"
            filter={false}
            h="200px"
          >
            <Button
              onClick={() => openDeleteConfirmation(value)}
              variant="outline"
              w="141px"
              border="1px solid #F5F5FB"
              pos="absolute"
              bottom="24px"
              color="white"
              right="24px"
              borderRadius="10px"
              _hover={{
                bg: 'none',
              }}
            >
              Remover
            </Button>
          </Resume>
        ))}
      </Grid>

      <AttentionModal
        isOpen={deleteConfirmationIsOpen}
        submit={handleDelete}
        onClose={() => setDeleteConfirmationIsOpen(false)}
        title="Deseja excluir esse questionário?"
        isLoading={deleteSubmitIsLoading}
      />

      <SuccessModal
        isOpen={success}
        onClose={handleClose}
        title="Questionário removido com sucesso"
      />
    </MainContent>
  );
}
